function cov_23pftcmjam() {
  var path = "/app/src/utils/get-formatted-amount.ts";
  var hash = "bed442249ff4036da5302d12dc20191e6fc5cbe5";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/utils/get-formatted-amount.ts",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 30
        },
        end: {
          line: 18,
          column: 1
        }
      },
      "1": {
        start: {
          line: 4,
          column: 2
        },
        end: {
          line: 17,
          column: 3
        }
      },
      "2": {
        start: {
          line: 8,
          column: 6
        },
        end: {
          line: 11,
          column: 8
        }
      },
      "3": {
        start: {
          line: 13,
          column: 6
        },
        end: {
          line: 16,
          column: 8
        }
      },
      "4": {
        start: {
          line: 20,
          column: 34
        },
        end: {
          line: 41,
          column: 1
        }
      },
      "5": {
        start: {
          line: 25,
          column: 24
        },
        end: {
          line: 25,
          column: 29
        }
      },
      "6": {
        start: {
          line: 27,
          column: 2
        },
        end: {
          line: 31,
          column: 3
        }
      },
      "7": {
        start: {
          line: 28,
          column: 4
        },
        end: {
          line: 28,
          column: 55
        }
      },
      "8": {
        start: {
          line: 29,
          column: 9
        },
        end: {
          line: 31,
          column: 3
        }
      },
      "9": {
        start: {
          line: 30,
          column: 4
        },
        end: {
          line: 30,
          column: 24
        }
      },
      "10": {
        start: {
          line: 33,
          column: 25
        },
        end: {
          line: 38,
          column: 27
        }
      },
      "11": {
        start: {
          line: 40,
          column: 2
        },
        end: {
          line: 40,
          column: 24
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 3,
            column: 30
          },
          end: {
            line: 3,
            column: 31
          }
        },
        loc: {
          start: {
            line: 3,
            column: 78
          },
          end: {
            line: 18,
            column: 1
          }
        },
        line: 3
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 20,
            column: 34
          },
          end: {
            line: 20,
            column: 35
          }
        },
        loc: {
          start: {
            line: 24,
            column: 5
          },
          end: {
            line: 41,
            column: 1
          }
        },
        line: 24
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 4,
            column: 2
          },
          end: {
            line: 17,
            column: 3
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 5,
            column: 4
          },
          end: {
            line: 5,
            column: 15
          }
        }, {
          start: {
            line: 6,
            column: 4
          },
          end: {
            line: 6,
            column: 15
          }
        }, {
          start: {
            line: 7,
            column: 4
          },
          end: {
            line: 11,
            column: 8
          }
        }, {
          start: {
            line: 12,
            column: 4
          },
          end: {
            line: 16,
            column: 8
          }
        }],
        line: 4
      },
      "1": {
        loc: {
          start: {
            line: 27,
            column: 2
          },
          end: {
            line: 31,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 27,
            column: 2
          },
          end: {
            line: 31,
            column: 3
          }
        }, {
          start: {
            line: 29,
            column: 9
          },
          end: {
            line: 31,
            column: 3
          }
        }],
        line: 27
      },
      "2": {
        loc: {
          start: {
            line: 28,
            column: 22
          },
          end: {
            line: 28,
            column: 54
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 28,
            column: 22
          },
          end: {
            line: 28,
            column: 49
          }
        }, {
          start: {
            line: 28,
            column: 53
          },
          end: {
            line: 28,
            column: 54
          }
        }],
        line: 28
      },
      "3": {
        loc: {
          start: {
            line: 29,
            column: 9
          },
          end: {
            line: 31,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 29,
            column: 9
          },
          end: {
            line: 31,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 29
      },
      "4": {
        loc: {
          start: {
            line: 35,
            column: 4
          },
          end: {
            line: 37,
            column: 39
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 36,
            column: 8
          },
          end: {
            line: 36,
            column: 62
          }
        }, {
          start: {
            line: 37,
            column: 8
          },
          end: {
            line: 37,
            column: 39
          }
        }],
        line: 35
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "bed442249ff4036da5302d12dc20191e6fc5cbe5"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_23pftcmjam = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_23pftcmjam();
cov_23pftcmjam().s[0]++;
var getCurrencyIntlConfig = function getCurrencyIntlConfig(currency) {
  cov_23pftcmjam().f[0]++;
  cov_23pftcmjam().s[1]++;
  switch (currency) {
    case 'BHD':
      cov_23pftcmjam().b[0][0]++;
    case 'KWD':
      cov_23pftcmjam().b[0][1]++;
    case 'QAR':
      cov_23pftcmjam().b[0][2]++;
      cov_23pftcmjam().s[2]++;
      return {
        minimumFractionDigits: 3,
        maximumFractionDigits: 3
      };
    default:
      cov_23pftcmjam().b[0][3]++;
      cov_23pftcmjam().s[3]++;
      return {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      };
  }
};
cov_23pftcmjam().s[4]++;
export var getFormattedAmount = function getFormattedAmount(price, currency, hideFractionalPart) {
  cov_23pftcmjam().f[1]++;
  var normalizedPrice = (cov_23pftcmjam().s[5]++, price);
  cov_23pftcmjam().s[6]++;
  if (typeof normalizedPrice === 'string') {
    cov_23pftcmjam().b[1][0]++;
    cov_23pftcmjam().s[7]++;
    normalizedPrice = (cov_23pftcmjam().b[2][0]++, parseFloat(normalizedPrice)) || (cov_23pftcmjam().b[2][1]++, 0);
  } else {
    cov_23pftcmjam().b[1][1]++;
    cov_23pftcmjam().s[8]++;
    if (Number.isNaN(normalizedPrice)) {
      cov_23pftcmjam().b[3][0]++;
      cov_23pftcmjam().s[9]++;
      normalizedPrice = 0;
    } else {
      cov_23pftcmjam().b[3][1]++;
    }
  }
  var formattedPrice = (cov_23pftcmjam().s[10]++, new Intl.NumberFormat('en-US', hideFractionalPart ? (cov_23pftcmjam().b[4][0]++, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }) : (cov_23pftcmjam().b[4][1]++, getCurrencyIntlConfig(currency))).format(normalizedPrice));
  cov_23pftcmjam().s[11]++;
  return formattedPrice;
};